import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import style from './Curtains.module.scss';
import { CurtainsFabricDetails, CurtainsHardwareDetails, PanelDetails } from "./CurtainsConstant";
import { saveUpdatedPageDetails, saveMetaDataUpdate } from "../../../actions/wizard";
import defaultImage from '../../../assets/default.png';

const CivilFloorMarbleLaying = (props: any) => {
  const dispatch = useDispatch();
  const { isDrawingsExporting } = props;
  const pageDetails = useSelector((state: any) => state.wizard.pageDetails);
  const requiredMetaDataUpdate = useSelector((state: any) => state.wizard.requiredMetaDataUpdate);

  const latestStateRef = useRef(requiredMetaDataUpdate);

  const [updatedValues, setUpdatedValues] = useState(pageDetails);

  useEffect(() => {
    setUpdatedValues(pageDetails)
  }, [pageDetails]);

  // Update the meta details while unmounting.
  useEffect(() => {
    return () => {
      updateDetailsInMeta(false);
    }
  }, [])

  // Updating Item details in meta data
  const updateItems = (details: any) => {
    const updatedObj: any = {
      ...updatedValues,
      metaData: {
        ...updatedValues?.metaData,
        [details.id]: details.value
      }
    };
    setUpdatedValues(updatedObj)
    dispatch(saveMetaDataUpdate(updatedObj))
  }

  // Save function to save details in API
  const updateDetailsInMeta = (required: boolean) => {
    if (latestStateRef.current) {
      dispatch(saveUpdatedPageDetails(latestStateRef.current, required));
      dispatch(saveMetaDataUpdate(false))
    }
  }

  // Created a debounce to update the exiting quote details 
  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      updateDetailsInMeta(true);
    }, 4000); // Adjust the delay (in milliseconds) as needed

    latestStateRef.current = requiredMetaDataUpdate;

    return () => {
      clearTimeout(debounceTimer);
    };
  }, [requiredMetaDataUpdate]);

  const fabricDetails = updatedValues?.curtainsDetails?.length ? updatedValues?.curtainsDetails : CurtainsFabricDetails;
  const hardwareDetails = updatedValues?.curtainsDetails?.length ? updatedValues?.curtainsDetails : CurtainsHardwareDetails;
  const panelDetails = updatedValues?.curtainsDetails?.length ? updatedValues?.curtainsDetails : PanelDetails;

  return (
    <section className={style.curtains_room_container}>
      <h2 className="section_heading">{updatedValues?.name}</h2>
      <div className={style.curtains_details_tabs}>
        <div className={style.curtains_work_image_columns}>
          <section style={{ gridTemplateRows: '1fr max-content 1fr' }}>
            <div className={style.left_image_section}>
              <p>Key Plan of the House / <br /> Site Photograph of the Room</p>
            </div>
            <hr />
            <div className={style.left_image_section}>
              {updatedValues?.images?.length ? <img crossOrigin="anonymous" src={updatedValues?.images[0] ? `${updatedValues?.images[0]}?ver=${new Date().getTime()}`: defaultImage} alt="" style={{ maxHeight: updatedValues?.images?.length > 1 ? '170px' : '190px' }} className="image-view" /> : <p>Fabric Image(s)</p>}
            </div>
          </section>
          <section>
            <div>
              <p>Window Elevation with</p>
              <p>a) Overall Window Dimensions (X & Y Axis); </p>
              <p>b) Overall Curtain Dimensions (X+10" & Y+10")</p>
              <span>Designer to denote each panel as (Panel Code A,B, C, D etc.) with Legend Below:</span>
              <p>Panel A: Panel Dimension: Panel Size (Width & Height): Panel Fabric</p>
            </div>
            {
              updatedValues?.curtainsDetails?.some((e: any) => e?.designType) ? (
                <div className={style.right_image_section}>
                  {updatedValues?.curtainsDetails?.map((e: any, i: number) => (
                    <img key={i} crossOrigin="anonymous" src={e?.designType ? `${e?.designType}?ver=${new Date().getTime()}` : defaultImage} alt="" style={{ maxHeight: '170px' }} className="image-view" />
                  ))}
                </div>
              ) : ''
            }
          </section>
        </div>
        <div className={style.curtains_work_details_tabs}>
          <div className={style.curtains_item_container}>
            <h2 className="sub_tab_heading">Curtain Fabric Details</h2>
            <div className={style.demolition_item_details}>
              <div className={style.curtains_items_heading}>
                <h4>Brand</h4>
                <h4>Header Style</h4>
              </div>
              <div className={style.curtains_items_list}>
                {
                  fabricDetails?.map((e, i) => (
                    <>
                      <p>
                        <div className={style.option_view}>
                          {!isDrawingsExporting ? <input value={updatedValues?.metaData?.[`brand_${i}`] || e?.[`brand_${i}`] || ''} onChange={(v) => updateItems({ id: `brand_${i}`, value: v.target.value })} /> : <span>{updatedValues?.metaData?.[`brand_${i}`] || e?.[`brand_${i}`] || '-'}</span>}
                        </div>
                      </p>
                      <p>
                        <div className={style.option_view}>
                          {!isDrawingsExporting ? <input value={updatedValues?.metaData?.[`header_style_${i}`] || e?.[`header_style_${i}`] || ''} onChange={(v) => updateItems({ id: `header_style_${i}`, value: v.target.value })} /> : <span>{updatedValues?.metaData?.[`header_style_${i}`] || e?.[`header_style_${i}`] || '-'}</span>}
                        </div>
                      </p>
                    </>
                  ))
                }
              </div>
            </div>
          </div>
          <div className={style.curtains_item_container}>
            <h2 className="sub_tab_heading">Hardware Details</h2>
            <div className={style.demolition_item_details_hardware}>
              <div className={style.curtains_items_heading_hardware}>
                <h4>Hardware Type</h4>
                <h4>Type</h4>
                <h4>Finial Design</h4>
                <h4>Finial & Rod Colour</h4>
                <h4>Length</h4>
              </div>
              <div className={`${style.curtains_items_list} ${style.curtains_items_heading_hardware}`}>
                {
                  hardwareDetails?.map((e, i) => (
                    <>
                      <p>
                        <div className={style.option_view}>
                          {!isDrawingsExporting ? <input value={updatedValues?.metaData?.[`hardware_type_${i}`] || e?.[`hardware_type_${i}`] || ''} onChange={(v) => updateItems({ id: `hardware_type_${i}`, value: v.target.value })} /> : <span>{updatedValues?.metaData?.[`hardware_type_${i}`] || e?.[`hardware_type_${i}`] || '-'}</span>}
                        </div>
                      </p>
                      <p>
                        <div className={style.option_view}>
                          {!isDrawingsExporting ? <input value={updatedValues?.metaData?.[`type_${i}`] || e?.[`type_${i}`] || ''} onChange={(v) => updateItems({ id: `type_${i}`, value: v.target.value })} /> : <span>{updatedValues?.metaData?.[`type_${i}`] || e?.[`type_${i}`] || '-'}</span>}
                        </div>
                      </p>
                      <p>
                        <div className={style.option_view}>
                          {!isDrawingsExporting ? <input value={updatedValues?.metaData?.[`finial_design_${i}`] || e?.[`finial_design_${i}`] || ''} onChange={(v) => updateItems({ id: `finial_design_${i}`, value: v.target.value })} /> : <span>{updatedValues?.metaData?.[`finial_design_${i}`] || e?.[`finial_design_${i}`] || '-'}</span>}
                        </div>
                      </p>
                      <p>
                        <div className={style.option_view}>
                          {!isDrawingsExporting ? <input value={updatedValues?.metaData?.[`rod_colour_${i}`] || e?.[`rod_colour_${i}`] || ''} onChange={(v) => updateItems({ id: `rod_colour_${i}`, value: v.target.value })} /> : <span>{updatedValues?.metaData?.[`rod_colour_${i}`] || e?.[`rod_colour_${i}`] || '-'}</span>}
                        </div>
                      </p>
                      <p>
                        <div className={style.option_view}>
                          {!isDrawingsExporting ? <input value={updatedValues?.metaData?.[`length_${i}`] || e?.[`length_${i}`] || ''} onChange={(v) => updateItems({ id: `length_${i}`, value: v.target.value })} /> : <span>{updatedValues?.metaData?.[`length_${i}`] || e?.[`length_${i}`] || '-'}</span>}
                        </div>
                      </p>
                    </>
                  ))
                }
              </div>
            </div>
          </div>
        </div>
        <div className={style.curtains_item_container}>
          <h2 className="sub_tab_heading">Panel Details</h2>
          <div className={style.demolition_item_details_panel}>
            <div className={style.curtains_items_heading_panel}>
              <h4>Panel Name (as per dwg)</h4>
              <h4>Fabric Name</h4>
              <h4>Type</h4>
              <h4>Lining</h4>
              <h4>Panel Width</h4>
              <h4>Panel Height</h4>
              <h4>Qty</h4>
            </div>
            <div className={`${style.curtains_items_list} ${style.curtains_items_heading_panel}`}>
              {
                panelDetails?.map((e, i) => (
                  <>
                    <p>
                      <div className={style.option_view}>
                        {!isDrawingsExporting ? <input value={updatedValues?.metaData?.[`panel_name_${i}`] || e?.[`panel_name_${i}`] || ''} onChange={(v) => updateItems({ id: `panel_name_${i}`, value: v.target.value })} /> : <span>{updatedValues?.metaData?.[`panel_name_${i}`] || e?.[`panel_name_${i}`] || '-'}</span>}
                      </div>
                    </p>
                    <p>
                      <div className={style.option_view}>
                        {!isDrawingsExporting ? <input value={updatedValues?.metaData?.[`fabric_name_${i}`] || e?.[`fabric_name_${i}`] || ''} onChange={(v) => updateItems({ id: `fabric_name_${i}`, value: v.target.value })} /> : <span>{updatedValues?.metaData?.[`fabric_name_${i}`] || e?.[`fabric_name_${i}`] || '-'}</span>}
                      </div>
                    </p>
                    <p>
                      <div className={style.option_view}>
                        {!isDrawingsExporting ? <input value={updatedValues?.metaData?.[`panel_type_${i}`] || e?.[`panel_type_${i}`] || ''} onChange={(v) => updateItems({ id: `panel_type_${i}`, value: v.target.value })} /> : <span>{updatedValues?.metaData?.[`panel_type_${i}`] || e?.[`panel_type_${i}`] || '-'}</span>}
                      </div>
                    </p>
                    <p>
                      <div className={style.option_view}>
                        {!isDrawingsExporting ? <input value={updatedValues?.metaData?.[`lining_${i}`] || e?.[`lining_${i}`] || ''} onChange={(v) => updateItems({ id: `lining_${i}`, value: v.target.value })} /> : <span>{updatedValues?.metaData?.[`lining_${i}`] || e?.[`lining_${i}`] || '-'}</span>}
                      </div>
                    </p>
                    <p>
                      <div className={style.option_view}>
                        {!isDrawingsExporting ? <input value={updatedValues?.metaData?.[`panel_width_${i}`] || e?.[`panel_width_${i}`] || ''} onChange={(v) => updateItems({ id: `panel_width_${i}`, value: v.target.value })} /> : <span>{updatedValues?.metaData?.[`panel_width_${i}`] || e?.[`panel_width_${i}`] || '-'}</span>}
                      </div>
                    </p>
                    <p>
                      <div className={style.option_view}>
                        {!isDrawingsExporting ? <input value={updatedValues?.metaData?.[`panel_height_${i}`] || e?.[`panel_height_${i}`] || ''} onChange={(v) => updateItems({ id: `panel_height_${i}`, value: v.target.value })} /> : <span>{updatedValues?.metaData?.[`panel_height_${i}`] || e?.[`panel_height_${i}`] || '-'}</span>}
                      </div>
                    </p>
                    <p>
                      <div className={style.option_view}>
                        {!isDrawingsExporting ? <input value={updatedValues?.metaData?.[`quantity_${i}`] || e?.[`quantity_${i}`] || ''} onChange={(v) => updateItems({ id: `quantity_${i}`, value: v.target.value })} /> : <span>{updatedValues?.metaData?.[`quantity_${i}`] || e?.[`quantity_${i}`] || '-'}</span>}
                      </div>
                    </p>
                  </>
                ))
              }
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default CivilFloorMarbleLaying;